<template>
  <div v-if="filters.length > 0" class="filters-info">
    <v-subheader>
      {{ lang.historic.filters.title }}
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            small
            @click.stop="clearFilters()"
            class="mr-2 clear-btn"
            color="gray darken-2"
          >
            <v-icon small>mdi-broom</v-icon>
          </v-btn>
        </template>
        <span>{{ lang.historic.filters.clear }}</span>
      </v-tooltip>
    </v-subheader>
    <v-row
      v-for="(filter, i) in filters"
      :key="i"
      class="filter"
    >
      <v-col cols="5" class="filter-label">
        {{ filter.label }}
      </v-col>
      <v-col cols="7" class="filter-text">
        <p v-if="!Array.isArray(filter.text)">{{ filter.text }}</p>
        <template v-else>
          <p
            v-for="(value, i_) in filter.text"
            :key="`val-${i_}`"
          >
            {{ value }}
          </p>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import defaults from '@/mixins/defaults/filters'

export default {
  mixins: [ appdata, utils ],
  computed: {
    filters () {
      let filters = (this.get_global.filters.customers && this.get_global.filters.customers.data ? { ...this.get_global.filters.customers.data } : false)
      let filters_ = []
      Object.keys(filters).forEach((key) => {
        let value = filters[key]
        let label = false
        let text = false
        switch (key) {
          case 'date':
            label = this.lang.historic.filters.date_range.date
            text = (value.length === 2 && (value[0] && value[0] !== '0000-00-00' && value[1] && value[1] !== '0000-00-00') ? `${this.formatDate(value[0], false)} ~ ${this.formatDate(value[1], false)}` : false)
            break
          case 'addresses':
            label = this.lang.historic.filters.addresses.title
            text = (value.length > 0 ? value.map((address) => address.cep) : false)
            break
          case 'phones':
            label = this.lang.historic.filters.phones.title
            text = (value.length > 0 ? value : false)
            break
          case 'identities':
            label = this.lang.historic.filters.identities.title
            text = (value.length > 0 ? value : false)
            break
        }
        if (label && text) filters_.push({ label, text })
      })
      console.log('filters_', filters_)
      return filters_
    }
  },
  watch: {
    '$store.state.global.filters.customers.data': {
      deep: true,
      handler () {
        this.$forceUpdate()
      }
    }
  },
  methods: {
    clearFilters () {
      this.$store.dispatch('setGlobalFilters', Object.assign({}, { customers: { ...defaults.customers } }))
      this.$store.dispatch('socket/CUSTOM_DATA', this.get_global.filters)
    }
  }
}
</script>
